import { pipePromise, handleStatuses } from 'utils';

import { Api } from './constants';

export const fetchSalesReport = pipePromise(
  (fromDate, toDate, options) => {
    const { token, publisherId } = options;

    return fetch(Api.FetchSalesReport(fromDate, toDate), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
    });
  },
  handleStatuses(),
  (response) => response.json()
);
